import { attributes } from "@type-r/models";

export type GoverningLaw = InstanceType<typeof GoverningLaw>;

export const GoverningLaw = attributes({
    name: String,
    code: String,
    isActive: Boolean
});